// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import  './support/entrypoint'
import rule from './support/rule'
import dictionary from './support/dictionary'
import layuiTable from './components/common/LayuiTable'
import layuiTableSelect from './components/common/LayuiTableSelect'
import layuiSelect from './components/common/LayuiSelect'
import layuiMultiSelect from './components/common/LayuiMultiSelect'
import layuiCheck from './components/common/LayuiCheck'
import layuiSwitch from './components/common/LayuiSwitch'
import layuiRadio from './components/common/LayuiRadio'
import layuiYear from './components/common/LayuiYear'
import layuiYearmonth from './components/common/LayuiYearmonth'
import layuiDate from './components/common/LayuiDate'
import layuiDatetime from './components/common/LayuiDatetime'
import layuiDaterange from './components/common/LayuiDaterange'
import layuiDatetimerange from './components/common/LayuiDatetimerange'
import layuiLayer from './components/common/LayuiLayer'
import layuiForm from './components/common/LayuiForm'
import layuiTree from './components/common/LayuiTree'
import layuiTreeselect from './components/common/LayuiTreeSelect'
import layuiTabletree from './components/common/LayuiTabletree'
import layuiZqSelect from './components/common/LayuiZqSelect'
import layuiFileupload from './components/common/LayuiFileUpload'
import layuiVideoupload from './components/common/LayuiVideoUpload'
import layuiFileuploadData from './components/common/LayuiFileUploadData'
import layuiListFileUpload from './components/common/LayuiListFileUpload'
import layuiImgupload from './components/common/LayuiImgUpload'
import layuiExportExcel from './components/common/LayuiExportExcel'
import layuiCollapse from './components/common/LayuiCollapse'
import pubCollapse from './components/common/pub-collapse'
import pubSearch from './components/common/pub-search'
import pubTabs from './components/common/pub-tabs'
import pubForm from './components/common/pub-form'
import advancedQuery from './components/common/AdvancedQuery'
import layuiTableConfig from './components/common/LayuiTableConfig'
import regionSelect from './components/common/RegionSelect'
import api from './network/request'
import security from './support/security'
import App from './components/App'
import { DatePicker, Select, Option, Loading, Checkbox , Cascader,Switch, Button, Dialog, InputNumber, Tabs, TabPane, Table, TableColumn, Pagination} from 'element-ui'
import AMap from 'vue-amap';
import moment from 'moment'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';

// 全局事件总线，用来处理各个组件之间通信问题的手段之一
Vue.prototype.$bus = window.$vue_bus = new Vue();
Vue.config.productionTip = false
Vue.prototype.layui = null;
Vue.prototype.layer = layuiLayer;
Vue.prototype.api = api;
Vue.prototype.uuid = window.uuid;
Vue.prototype.dict = dictionary;
Vue.prototype.ruleObj = rule;
Vue.prototype.security = security;
Vue.component('layui-form', layuiForm);
Vue.component('layui-table', layuiTable);
Vue.component('layui-tableselect', layuiTableSelect);
Vue.component('layui-multiselect', layuiMultiSelect);
Vue.component('layui-select', layuiSelect);
Vue.component('layui-year', layuiYear);
Vue.component('layui-date', layuiDate);
Vue.component('layui-datetime', layuiDatetime);
Vue.component('layui-daterange', layuiDaterange);
Vue.component('layui-datetimerange', layuiDatetimerange);
Vue.component('layui-tree', layuiTree);
Vue.component('layui-tabletree', layuiTabletree);
Vue.component('layui-treeselect', layuiTreeselect);
Vue.component('layui-check', layuiCheck);
Vue.component('layui-switch',layuiSwitch);
Vue.component('layui-radio', layuiRadio);
Vue.component('layui-exportexcel', layuiExportExcel);
Vue.component('layui-zqselect', layuiZqSelect);
Vue.component('layui-fileupload', layuiFileupload);
Vue.component('layui-listfileupload', layuiListFileUpload);
Vue.component('layui-videoupload', layuiVideoupload);
Vue.component('layui-fileupload-data', layuiFileuploadData);
Vue.component('layui-imgupload', layuiImgupload);
Vue.component('layui-yearmonth', layuiYearmonth);
Vue.component('layui-collapse', layuiCollapse);
Vue.component('pub-collapse', pubCollapse);
Vue.component('pub-search', pubSearch);
Vue.component('pub-tabs', pubTabs);
Vue.component('pub-form', pubForm);
Vue.component('layui-tableconfig', layuiTableConfig);
Vue.component('advanced-query', advancedQuery);
Vue.component('region-select', regionSelect);

Vue.component(Checkbox.name, Checkbox)
Vue.component(Select.name, Select)
Vue.component(Option.name, Option)
Vue.component(DatePicker.name, DatePicker)
Vue.component(Cascader.name, Cascader)
Vue.component(Switch.name, Switch)
Vue.component(Button.name, Button)
Vue.component(Dialog.name, Dialog)
Vue.component(InputNumber.name, InputNumber)
Vue.component(Tabs.name, Tabs)
Vue.component(TabPane.name, TabPane)
Vue.component(Table.name, Table)
Vue.component(TableColumn.name, TableColumn)
Vue.component(Pagination.name, Pagination)

Vue.use(Loading.directive)

window.moment = moment

Vue.use(AMap);
window._AMapSecurityConfig = {
  securityJsCode: 'b73c073c5e63ca88df8524d9315ad5c1'
}
// 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德key
  key: '4184924e1a1afb25a987fec3b89f27b6',
  // 插件集合 （插件按需引入）
  plugin: ['AMap.Geolocation','AMap.PlaceSearch','AMap.Autocomplete','AMap.ToolBar','AMap.OverView','AMap.Scale']
});

layui.extend({
   loading: '/static/plugin/layui_exts/loading/loading',
   tableEdit:'/static/plugin/layui_exts/tableTree/tableEdit',
   tableTree:'/static/plugin/layui_exts/tableTree/tableTree',
   tableFilter: '/static/plugin/layui_exts/tableFilter/tableFilter',
   tableSelect:  '/static/plugin/layui_exts/tableSelect/tableSelect',
}).use(['dropdown','element', 'layer','form','table','laydate','tableFilter', 'tree', 'loading', 'tableEdit', 'tableTree','tableSelect','xmSelect'], function(){

    Vue.prototype.layui = layui;

    baseVm = new Vue({
      el: '#ywpt',
     // router,
      data (){
        return {

        }
      },
      render: h => h(App),
      mounted() {

      },
      methods: {

      }
    })
});





// WEBPACK FOOTER //
// ./src/main.js